import 'ui-common'
import '@/components'

export { default as router } from '@/router'
export { default as vuetify } from './vuetify'
export { default as i18n } from './vue-i18n'
